module.exports = __webpack_public_path__ + "static/4-3a99459918ca5894d14de62c8b5bdc4a.jpg";